import React, { useCallback, useEffect, useMemo, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { getWarehouseKeyValueList } from "../../../services/index";
import PaginationDataTable from "../../Common/PaginationDataTable";
import { STORE_TRANSFER_URL } from "../../../CONSTANTS";
import { storeTransferApprove, storeTransferCancel } from "../../../services/Inventory/StoreTransferService";

const StoreTransferList = () => {
    const navigate = useNavigate();
    const [wareOptions, setWareOptions] = useState([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState({ value: "", label: "Select Warehouse" });
    const [refreshFlag, setRefreshFlag] = useState(0);

    const handleRefresh = useCallback(() => {
        setRefreshFlag((f) => f + 1);
    }, []);

    const handleApprove = useCallback((row) => {
        if (!window.confirm(`Approve ${row.storeTransferCode}? Stock will move to the new location.`)) {
            return;
        }
        storeTransferApprove(row.uuid).then((res) => {
            if (res.errorCode === 0) {
                toast.success(res.message);
                handleRefresh();
            } else {
                toast.error(res.message);
            }
        }).catch(() => toast.error("Approve failed. Please try again."));
    }, [handleRefresh]);

    const handleCancel = useCallback((row) => {
        if (!window.confirm(`Cancel ${row.storeTransferCode}?`)) {
            return;
        }
        storeTransferCancel(row.uuid).then((res) => {
            if (res.errorCode === 0) {
                toast.success(res.message);
                handleRefresh();
            } else {
                toast.error(res.message);
            }
        }).catch(() => toast.error("Cancel failed. Please try again."));
    }, [handleRefresh]);

    const columns = useMemo(() => [
        { name: "CODE", cell: (row) => row.storeTransferCode, style: { color: "#007bff" } },
        { name: "DATE", cell: (row) => row.storeTransferDate },
        { name: "WAREHOUSE", cell: (row) => row.warehouseTitle },
        { name: "CREATED BY", cell: (row) => row.storeTransferByUserTitle },
        { name: "STATUS", cell: (row) => row.storeTransferStatusEnum },
        {
            name: "ACTION",
            style: { cursor: "pointer" },
            cell: (row) => (
                <div onClick={(e) => e.stopPropagation()}>
                    {row.storeTransferStatusEnum === "Pending" ? (
                        <>
                            <ThumbUpAltIcon
                                titleAccess="Approve"
                                style={{ fontSize: "18px", cursor: "pointer", color: "green" }}
                                onClick={() => handleApprove(row)}
                            />
                            &nbsp;&nbsp;
                            <HighlightOffIcon
                                titleAccess="Cancel"
                                style={{ fontSize: "18px", cursor: "pointer", color: "red" }}
                                onClick={() => handleCancel(row)}
                            />
                        </>
                    ) : (
                        <>-</>
                    )}
                </div>
            ),
        },
    ], [handleApprove, handleCancel]);

    useEffect(() => {
        getWarehouseKeyValueList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({ value: d.key, label: d.value })) || [];
                setWareOptions(options);
                if (options.length > 0) {
                    setSelectedWarehouse(options[0]);
                }
            } else {
                toast.error(res.message);
            }
        });
    }, []);

    // PaginationDataTable re-fetches when the filter object changes.
    const filter = useMemo(() => ({ uuid2: selectedWarehouse?.value, refresh: refreshFlag }), [selectedWarehouse, refreshFlag]);

    return (
        <>
            <div className="p-4">
                <div className="d-flex justify-content-between align-items-center">
                    <h3 className="mb-0 font-size-18 font-weight-bolder text-uppercase w-100">Store to Store Transfer</h3>
                </div>
                <div className="tab-content issuanceList" id="myTabContent">
                    <div className="tab-pane fade show active" role="tabpanel">
                        <div className="issuance-warehouse" style={{ zIndex: 6 }}>
                            <Select
                                options={wareOptions}
                                placeholder={"Select Warehouse"}
                                onChange={(e) => setSelectedWarehouse(e)}
                                value={selectedWarehouse}
                                maxMenuHeight={220}
                            />
                        </div>
                        <div className="excel-postn mt-2">
                            <Link to="/storeTransfer/new">
                                <button className="tooltip-container ember-view btn btn-primary d-flex align-items-center" type="button">
                                    <AddIcon />
                                    New
                                </button>
                            </Link>
                        </div>
                        {selectedWarehouse?.value && (
                            <PaginationDataTable
                                paginationUrl={STORE_TRANSFER_URL() + "getAllRecords"}
                                serverSidePagination={true}
                                search={true}
                                pagination={false}
                                className="position-relative customDataTable"
                                columns={columns}
                                showNewBtn={true}
                                filter={filter}
                                loading={true}
                                onRowClicked={(row) => navigate(`/storeTransfer/${row.uuid}`)}
                            />
                        )}
                    </div>
                </div>
            </div>
            <Toaster />
        </>
    );
};

export default StoreTransferList;
